var _defs, _path, _path2, _rect, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _ellipse, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10080IconServiceNetworkInterfaces(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e0050721-e8d8-4c79-ae50-d8fc2871d932",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcad3287-b71c-44fa-971a-6a18bcf384a0",
    x1: 9.01,
    y1: 16.5,
    x2: 9.01,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e9641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#6baa42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#73b743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76bb43"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-networking-80") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.89,2.91h1.27a.34.34,0,0,1,.34.34v3.5a.34.34,0,0,1-.34.34H15.89a0,0,0,0,1,0,0V2.91A0,0,0,0,1,15.89,2.91Z",
    fill: "#ffca00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.89,9h1.27a.34.34,0,0,1,.34.34v5.86a.34.34,0,0,1-.34.34H15.89a0,0,0,0,1,0,0V9A0,0,0,0,1,15.89,9Z",
    fill: "#ffca00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.13,
    y: 1.5,
    width: 13.76,
    height: 15,
    rx: 0.69,
    fill: "url(#fcad3287-b71c-44fa-971a-6a18bcf384a0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9,12.9H5.19A.2.2,0,0,1,5,12.69V4.34a.19.19,0,0,1,.19-.2H7.12a.19.19,0,0,1,.19.2.2.2,0,0,1-.19.21H5.38v7.93H5.9a.2.2,0,0,1,.19.21A.21.21,0,0,1,5.9,12.9Z",
    fill: "#b4ec36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6,13.92H4.4a.2.2,0,0,1-.19-.21L4.08,3.38a.2.2,0,0,1,.06-.15.16.16,0,0,1,.13-.06H7.12v.41H4.47l.12,9.92H6Z",
    fill: "#b4ec36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12,13H10.41a.19.19,0,0,1-.14-.07.18.18,0,0,1-.06-.14V7.9a.19.19,0,0,1,.19-.2l.91,0,0-2.25h.38l0,2.44a.2.2,0,0,1-.18.21l-.91,0v4.42H12Z",
    fill: "#b4ec36"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.07,
    y: 2.29,
    width: 6.14,
    height: 3.11,
    rx: 0.26,
    fill: "#365615"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.86,
    y: 12.69,
    width: 4.9,
    height: 1.09,
    rx: 0.26,
    transform: "translate(21.54 4.93) rotate(90)",
    fill: "#365615"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.99,
    y: 12.71,
    width: 4.9,
    height: 1.09,
    rx: 0.26,
    transform: "translate(19.7 6.82) rotate(90)",
    fill: "#365615"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.98,
    y: 12.71,
    width: 4.9,
    height: 1.09,
    rx: 0.26,
    transform: "translate(25.68 0.83) rotate(90)",
    fill: "#f2f2f2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.11,
    cy: 8.06,
    rx: 1.04,
    ry: 1.12,
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.5,5.7H1.77A.34.34,0,0,1,2.11,6v5.86a.34.34,0,0,1-.34.34H.5a0,0,0,0,1,0,0V5.7A0,0,0,0,1,.5,5.7Z",
    transform: "translate(2.61 17.95) rotate(180)",
    fill: "#3b3b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10080IconServiceNetworkInterfaces);
export default __webpack_public_path__ + "static/media/10080-icon-service-Network-Interfaces.b9370d4e206e51a91b0c038fcf77b063.svg";
export { ForwardRef as ReactComponent };